module.exports = __webpack_public_path__ + "img/horseracing 3 .aec45c6f.webp";